import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
// import "./styles/index.scss";
import closeBtn from "./img/Close.svg";
import { getURLOrigin, logger } from "../../util/AppUtil";
import { toggleSessionExpiryOverlay } from "../../actions/ApplicationActions";
import { OmnitureUtil } from "../../util/OmnitureUtil";

const SessionExpiryOverlay = ({
  showSessionExpiryPopup = false,
  toggleSessionExpiryOverlay,
}) => {
  const { pathname } = useLocation();
  const isAmazonOnboardingPage = pathname === "/amazon";

  const closeHandler = () => {
    toggleSessionExpiryOverlay(false);
  };

  useEffect(() => {
    document.body.style["overflow"] = showSessionExpiryPopup ? "hidden" : "";
    if (showSessionExpiryPopup) {
      logger.info({
        appContext: {
          msg: "SHOWN_SESSION_EXPIRY_OVERLAY",
          page: pathname,
        },
      });
      OmnitureUtil.trackOverlay('Amazon session timed out overlay', 'Onboarding flow - Amazon session timed out overlay');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSessionExpiryPopup]);

  if (!showSessionExpiryPopup) {
    return <></>;
  }
  return (
    <div
      className={`popupContainer sessionexpiry-overlay ${
        isAmazonOnboardingPage ? "onboarding-page" : ""
      }`}
    >
      <div className="errorContainer">
        {isAmazonOnboardingPage && (
          <div className="closeBtn" onClick={closeHandler}>
            <img className="closeImg" src={closeBtn} alt="close icon" />
          </div>
        )}
        <div className="errorHeader">
          {"Page has timed out due to inactivity."}
        </div>
        {!isAmazonOnboardingPage && (
          <div className="errorDescription">
            <p className="error-item">
              {"Please start over to link your Amazon and Shutterfly accounts."}
            </p>
            <p className="error-item home-link">
              <a href={`${getURLOrigin()}/amazon?fromAmazon=true`}>
                {"Close and go to Landing page"}
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    showSessionExpiryPopup: state.app.showSessionExpiryPopup,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleSessionExpiryOverlay: (flag) => {
    dispatch(toggleSessionExpiryOverlay(flag));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SessionExpiryOverlay);
